import {
	LICENSED_PRODUCTS,
	getLicensedProducts,
} from '@atlassian/jira-common-util-get-tenant-context';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): boolean => {
	const products = getLicensedProducts();
	const { JIRA_SOFTWARE, JIRA_SERVICEDESK } = LICENSED_PRODUCTS;
	return products[JIRA_SOFTWARE] && products[JIRA_SERVICEDESK];
};
